const WOMEN_API_BASE_URL = 'https://api.bloomclinicwomen.com';

function parseBooleanFlag(value: string | undefined, fallback = false) {
  const normalized = String(value || '').trim().toLowerCase();

  if (!normalized) {
    return fallback;
  }

  return ['1', 'true', 'yes', 'on'].includes(normalized);
}

const explicitApiBaseUrl = String(import.meta.env.VITE_API_BASE_URL || '').trim();

// This is the women-only site: no runtime site-target switching.
export const apiBaseUrl = explicitApiBaseUrl || WOMEN_API_BASE_URL;
export const siteTarget = 'women' as const;
export const isVideoCarouselEnabled = parseBooleanFlag(
  import.meta.env.VITE_ENABLE_VIDEO_CAROUSEL,
  false
);
